module.exports = __webpack_public_path__ + "static/media/smmscrpt_100.e7e70540.ico";